module.exports = __webpack_public_path__ + "assets/img/more-info.6ace6037.webp";